import { Injectable, signal, Signal, TemplateRef } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SkeletonTemplateService {
  private _circleTemplate = signal<TemplateRef<unknown> | null>(null);
  private _rectangleTemplate = signal<TemplateRef<unknown> | null>(null);
  private _productListTemplate = signal<TemplateRef<unknown> | null>(null);
  private _productCardsTemplate = signal<TemplateRef<unknown> | null>(null);

  circleTemplate: Signal<TemplateRef<unknown> | null> = this._circleTemplate;
  rectangleTemplate: Signal<TemplateRef<unknown> | null> = this._rectangleTemplate;
  productListTemplate: Signal<TemplateRef<unknown> | null> = this._productListTemplate;
  productCardsTemplate: Signal<TemplateRef<unknown> | null> = this._productCardsTemplate;

  setCircleTemplate(template: TemplateRef<unknown>): void {
    this._circleTemplate.set(template);
  }

  setRectangleTemplate(template: TemplateRef<unknown>): void {
    this._rectangleTemplate.set(template);
  }

  setProductListTemplate(template: TemplateRef<unknown>): void {
    this._productListTemplate.set(template);
  }

  setProductCardsTemplate(template: TemplateRef<unknown>): void {
    this._productCardsTemplate.set(template);
  }
}
